import React from "react";
import { ExtractedArticleInformationType } from "../../types/ExtractedArticleInformationType";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { useParams } from "react-router";
import DefaultScannerComponentCameraControlled from "../../DefaultScannerComponentCameraControlled";
import { CreateMoreAddonOrdersModal } from "./CreateMoreAddonOrdersModal/CreateMoreAddonOrdersModal";

const DefaultScannerPage: React.FC = () => {
  const navigate = useFixaNavigate();
  const { type } = useParams<{ type: string }>();

  const handleResult = (result: ExtractedArticleInformationType) => {
    if (type === undefined || type === "global") {
      navigate(`/product/ART${result.articleNumber}`);
    } else {
      navigate(`/task/new/${type}`, {
        state: {
          product: {
            supplierNumber: result.supplierNumber,
            product: result.articleNumber,
            type: "ART",
          },
        },
      });
    }
  };

  return (
    <>
      <DefaultScannerComponentCameraControlled
        onResult={handleResult}
        withSearchPadding
        shouldShowLargeReadyToScan
      />
      {type === "addon" && <CreateMoreAddonOrdersModal />}
    </>
  );
};

export default DefaultScannerPage;
